(() => {
  const objectFitImage = (selectAllImages) => {
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    selectAllImages.forEach((image) => {
      if (image.currentStyle) {
        image.result = image.currentStyle['object-fit'];
      } else {
        image.result = image.getAttribute('data-object-fit');
      }

      (image.runtimeStyle || image.style).background = `url("${image.src}") no-repeat 50%/${image.result}`;
      image.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${image.width}' height='${image.height}'%3E%3C/svg%3E`;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    const anonymousHomePage = document.querySelectorAll('.ph-page-anonymoushomepage'),
        loggedInHomePage = document.querySelectorAll('.ph-page-homepage');

    if (('objectFit' in document.documentElement.style === false) && (anonymousHomePage.length > 0 || loggedInHomePage.length > 0)) {
      objectFitImage(document.querySelectorAll('img[data-object-fit]'));
    }
  });
})();
